import { DynamicModule, Logger, Module } from '@nestjs/common';
import { ServerConfigModuleOptions } from './models/server-config-module-options';
import {
  BCRYPT_SALT_ROUNDS,
  DB_CONFIG,
  FRONTEND_BASE_URL,
  JWT_SECRET,
  MESSENGER_SERVICE
} from './constants';

@Module({})
export class ServerConfigModule {
  static register(options: ServerConfigModuleOptions): DynamicModule {
    const providers = [];
    const exports = [];

    if (options.frontendBaseUrl) {
      providers.push({
        provide: FRONTEND_BASE_URL,
        useValue: options.frontendBaseUrl,
      });
      exports.push(FRONTEND_BASE_URL);
      Logger.log(
        'FRONTEND_BASE_URL: ' + options.frontendBaseUrl,
        'Token Injection'
      );
    }

    if (options.dbConfig) {
      providers.push({
        provide: DB_CONFIG,
        useValue: options.dbConfig,
      });
      exports.push(DB_CONFIG);
      Logger.log(
        'DB_CONFIG: ' + JSON.stringify(options.dbConfig),
        'Token Injection'
      );
    }

    if (options.bcryptSaltRounds) {
      providers.push({
        provide: BCRYPT_SALT_ROUNDS,
        useValue: options.bcryptSaltRounds,
      });
      exports.push(BCRYPT_SALT_ROUNDS);
      Logger.log(
        'BCRYPT_SALT_ROUNDS: ' + options.bcryptSaltRounds,
        'Token Injection'
      );
    }

    if (options.messengerService) {
      providers.push({
        provide: MESSENGER_SERVICE,
        useValue: options.messengerService,
      });
      exports.push(MESSENGER_SERVICE);
      Logger.log(
        'MESSENGER_SERVICE: ' + options.messengerService,
        'Token Injection'
      );
    }

    if (options.jwtSecret) {
      providers.push({
        provide: JWT_SECRET,
        useValue: options.jwtSecret,
      });
      exports.push(JWT_SECRET);
      Logger.log('JWT_SECRET: ' + options.jwtSecret, 'Token Injection');
    }

    return {
      global: true,
      module: ServerConfigModule,
      providers,
      exports,
    };
  }
}
